import { render } from "./FbHeader.vue?vue&type=template&id=4cd18e90"
import script from "./FbHeader.vue?vue&type=script&lang=js"
export * from "./FbHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__